<template>
  <b-container fluid class="position-relative">
    <div ref="menu-container" style="margin-bottom: 10px;">
      <recruiter-nav-menu-items/>
    </div>
    <!--- Show popup informations section start -->
    <b-container fluid class="position-relative breadcrumbs-container">
      <!-- <div class="d-flex justify-content-end align-items-center">
        <div class="my-n1 h-100 pr-3" style="right: 0;"> -->
          <i
              v-if="isInfoIconVisible"
              class="mdi mdi-information-outline clickable"
              aria-hidden="true"
              v-b-tooltip.hover
              title="Show information about this page"
              @click="showInfoPanelByButton"
          />
       <!-- </div>
       </div> -->
    </b-container>
    <portal to="info-popups">
      <InfoPopup
          :key="$route.path"
          v-if="showDashboardInfoPanel"
          v-model="isInfoPanelVisible"
          :user-settings-key="userSettingsKey"
          :with-cancel-possibility="isInfoPanelWithCancel"
          setting-key="DASHBOARD"
      >
        <div slot="title" class="v2_info-popup__title px-2">
          Using the Dashboard
        </div>
        <DashboardInfoPopupContent/>
      </InfoPopup>

      <InfoPopup
          :key="$route.path"
          v-else-if="$route.path === '/recruiter/ico'"
          v-model="isInfoPanelVisible"
          :user-settings-key="userSettingsKey"
          :with-cancel-possibility="isInfoPanelWithCancel"
          setting-key="EXCHANGE_DASHBOARD"
          class="using-connect-modal"
      >
        <div slot="title" class="v2_info-popup__title">
          Using Connect
        </div>
        <exchange-info-popup/>
      </InfoPopup>

      <InfoPopup
          :key="$route.path"
          v-else-if="$route.path.startsWith('/recruiter/inform')"
          v-model="isInfoPanelVisible"
          :user-settings-key="userSettingsKey"
          :with-cancel-possibility="isInfoPanelWithCancel"
          setting-key="FILTERS"
      >
        <div slot="title" class="v2_info-popup__title">
          Using Inform
        </div>
        <FiltersInfoPopup/>
      </InfoPopup>

    </portal>
    <!--- Show popup informations section end -->

<!--    <b-row class="d-flex justify-content-end">-->
<!--      <div-->
<!--        class="h-100 pr-3"-->
<!--        style="right: 0;"-->
<!--      >-->
<!--        <i-->
<!--          class="mdi mdi-information-outline clickable"-->
<!--          aria-hidden="true"-->
<!--          v-b-tooltip.hover-->
<!--          title="Show information about this page"-->
<!--          @click="showInfoPanelByButton"-->
<!--          :class="{ invisible: !isInfoIconVisible }"-->
<!--        />-->
<!--      </div>-->
<!--    </b-row>-->
  </b-container>
  
</template>

<script>
import InfoPopupParentMixin from "@/mixins/InfoPopupParentMixin";
import InfoPopup from '@/components/ui-elements/InfoPopup';
import RecruiterNavMenuItems from "@/components/layouts/recruiter/RecruiterNavMenuItems";
import DashboardInfoPopupContent from '@/components/recruiter/dashboard/DashboardInfoPopupContent';
import ExchangeInfoPopup from '@/components/recruiter/exchange/ExchangeInfoPopup';
import FiltersInfoPopup from '@/components/recruiter/inform/FiltersInfoPopup';

export default {
  name: 'RecruiterLayout',
  components: {
    RecruiterNavMenuItems,
    InfoPopup,
    DashboardInfoPopupContent,
    ExchangeInfoPopup,
    FiltersInfoPopup
  },
  data: function () {
    return {
      isInfoPanelVisible: false,
      isInfoPanelWithCancel: false,
      isFirstRender: false,
    };
  },
  mixins: [InfoPopupParentMixin],
  computed :{
    showDashboardInfoPanel: function () {
      return (
          this.$route.path === '/recruiter'
      );
    },
  },
  methods: {
    showInfoPanelByButton: function () {
      this.isInfoPanelVisible = true;
      this.isInfoPanelWithCancel = false;
      this.isFirstRender = false;
    },
  },
};
</script>

<style scoped>
.mdi.mdi-information-outline.clickable{
  position: absolute;
  z-index: 9;
  right: 10px;
  margin-top: 10px;
}
</style>
